import { useNavigate } from 'react-router';

import { useAuthService } from '~domains/auth';

import LogoutIcon from '~shared/assets/icons/logout.svg?react';
import ProfileIcon from '~shared/assets/icons/profile.svg?react';
import { ROUTES } from '~shared/config/routes';
import { ResponsiveMenu } from '~shared/ui/responsive-menu';

import { IconButton } from '@breezeventures/ui-kit/icon-button';

export const ProfileMenu = () => {
  const { logout } = useAuthService();
  const navigate = useNavigate();

  const items = [
    {
      key: 'profile',
      label: 'Profile',
      icon: <ProfileIcon />,
      onClick: () => navigate(ROUTES.profile),
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutIcon width={20} height={20} />,
      onClick: logout,
    },
  ];

  return (
    <ResponsiveMenu
      trigger={
        <IconButton variant="secondary" size="s" aria-label="Account menu">
          <ProfileIcon />
        </IconButton>
      }
      items={items}
    />
  );
};
